import { TierLadderItem } from "../model/types";
import styles from "./TierDetails.module.css";

interface Props {
  tier: TierLadderItem;
}

const rows = (tier: TierLadderItem) => {
  const payoutBonus = Math.trunc(Number(tier.payout_bonus_pct) * 100);

  return [
    { label: "Tier", value: tier.display_name },
    {
      label: "Min deposit",
      value: `$${Math.trunc(Number(tier.min_deposit_usdt)).toLocaleString("en-US")}`,
    },
    {
      label: "Max open orders",
      value: `$${Math.trunc(Number(tier.max_open_orders_usdt)).toLocaleString("en-US")}`,
    },
    ...(payoutBonus > 0
      ? [{ label: "Payout bonus", value: `+${payoutBonus}%` }]
      : []),
  ];
};

export const TierDetails = ({ tier }: Props) => {
  const benefitsItems = tier.benefits_items ?? [];

  return (
    <div className={styles.popup}>
      {rows(tier).map(({ label, value }) => (
        <div key={label} className={styles.row}>
          <span className={styles.label}>{label}</span>
          <span className={styles.value}>{value}</span>
        </div>
      ))}
      {benefitsItems.length > 0 && (
        <ul className={styles.benefits}>
          {benefitsItems.map((item) => (
            <li key={item} className={styles.benefitItem}>
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
